import { Box, Skeleton } from '@mui/material';

export default function HeaderSkeleton() {
    return (
        <Box>
            {/* Breadcrumb */}
            <Skeleton width={180} height={20} sx={{ mb: 2 }} />
            {/* Page title */}
            <Skeleton width={240} height={36} />
            {/* Roles */}
            <Skeleton width={180} height={20} />
        </Box>
    );
}
